// Generated by Melange

import * as Belt__Belt_Result from "melange.belt/belt_Result.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as $$Promise from "../../../../vendored/promise/promise.js";
import * as React from "react";

function validatedValueToOpt(param) {
  const x = param.validatedValue;
  if (x.TAG === /* Ok */0) {
    return Caml_option.some(x._0);
  }
  
}

function addField(form, handler, validator) {
  const submit = form.internalState.submit;
  const isValid = form.internalState.isValid;
  form.internalState.submit = (function (param) {
      Curry._1(submit, undefined);
      Curry._1(handler, undefined);
    });
  form.internalState.isValid = (function (param) {
      if (Curry._1(isValid, undefined)) {
        return Curry._1(validator, undefined);
      } else {
        return false;
      }
    });
}

function useForm(sendSubmit) {
  const match = React.useState(function () {
        return false;
      });
  const setSubmitting = match[1];
  const match$1 = React.useState(function () {
        return false;
      });
  const setShowErrors = match$1[1];
  const internalState = {
    submit: (function (param) {
        
      }),
    isValid: (function (param) {
        return true;
      })
  };
  return {
          submit: (function (parameters) {
              Curry._1(setSubmitting, (function (param) {
                      return true;
                    }));
              const __x = Curry._1(sendSubmit, parameters);
              return $$Promise.flatMap(__x, (function (result) {
                            Curry._1(setSubmitting, (function (param) {
                                    return false;
                                  }));
                            return $$Promise.resolved(result);
                          }));
            }),
          internalState: internalState,
          isSubmitting: match[0],
          isValid: (function (param) {
              return Curry._1(internalState.isValid, undefined);
            }),
          validate: (function (param) {
              const valid = Curry._1(internalState.isValid, undefined);
              Curry._1(setShowErrors, (function (param) {
                      return !valid;
                    }));
              return valid;
            }),
          showErrors: match$1[0]
        };
}

function useFieldWithReducer(form, param, validator, $staropt$star, reducer) {
  const setValue = param[1];
  const value = param[0];
  if ($staropt$star === undefined) {
    ((function (param) {
          if (param.isTouched) {
            return false;
          } else {
            return param.submitted;
          }
        }));
  }
  const match = React.useState(function () {
        return false;
      });
  const setIsTouched = match[1];
  const match$1 = React.useState(function () {
        return false;
      });
  const setIsSubmitted = match$1[1];
  const onSubmit = function (param) {
    Curry._1(setIsTouched, (function (param) {
            return false;
          }));
    Curry._1(setIsSubmitted, (function (param) {
            return true;
          }));
  };
  const validatedValue = Curry._1(validator, value);
  addField(form, onSubmit, (function (param) {
          return Belt__Belt_Result.isOk(validatedValue);
        }));
  let valueForDisplay;
  valueForDisplay = validatedValue.TAG === /* Ok */0 ? ({
        TAG: /* Ok */0,
        _0: validatedValue._0
      }) : (
      form.showErrors ? ({
            TAG: /* Error */1,
            _0: validatedValue._0
          }) : ({
            TAG: /* Ok */0,
            _0: value
          })
    );
  return {
          value: value,
          valueForDisplay: valueForDisplay,
          validatedValue: validatedValue,
          onChange: (function (action) {
              const nextValue = Curry._2(reducer, action, value);
              Curry._1(setValue, (function (param) {
                      return nextValue;
                    }));
              Curry._1(setIsTouched, (function (param) {
                      return true;
                    }));
            })
        };
}

function useField(form, state, displayError, validator) {
  return useFieldWithReducer(form, state, validator, displayError, (function (newValue, param) {
                return newValue;
              }));
}

const ExternalState = {
  useFieldWithReducer: useFieldWithReducer,
  useField: useField
};

function useFieldWithReducer$1(form, initialValue, validator, displayError, reducer) {
  return useFieldWithReducer(form, React.useState(function () {
                  return initialValue;
                }), validator, displayError, reducer);
}

function useField$1(form, initialValue, displayError, validator) {
  return useField(form, React.useState(function () {
                  return initialValue;
                }), displayError, validator);
}

export {
  validatedValueToOpt ,
  useForm ,
  useFieldWithReducer$1 as useFieldWithReducer,
  useField$1 as useField,
  ExternalState ,
}
/* Promise Not a pure module */
